<template>
   <v-row>
    <v-col cols="12">
      <v-card class="px-0">
        <v-skeleton-loader v-if="$store.state.purchases.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            Compras
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="purchase" class="mr-1" />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <purchase-list />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import PurchaseList from '@/components/purchase//PurchaseList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    PurchaseList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: [
      {
        type: 'text',
        id: 'supplier__name',
        label: 'Proveedor',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'date',
        label: 'Fecha',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'total',
        label: 'Total',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'number',
        label: 'Número',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ]
  }),
  methods: {
    getList () {
      this.$store.dispatch('purchases/LIST', {
        resource: 'purchases',
        query: this.$route.query
      })
    }
  }
}
</script>